/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/naming-convention */
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HotToastService } from '@ngneat/hot-toast';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { ProjectsService } from 'app/core/services/project/projects.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
@Component({
  selector: 'app-new-phase',
  templateUrl: './new-phase.component.html',
  styleUrls: ['./new-phase.component.scss']
})
export class NewPhaseComponent implements OnInit {
  phaseFormGroup: FormGroup;
  phaseDetails: any;
  dateFormat: string = 'DD/MM/YYYY';
  project_uid: string;
  isSubmitting: boolean = false;
  colors: string[] = ['#E11D48', '#2563EB', '#DB2777', '#D97706', '#7C3AED', '#EA580C', '#0891B2', '#4F46E5', '#059669'];
  selectedColor: string = '';
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<NewPhaseComponent>,
    private formBuilder: FormBuilder,
    private dataCollectorService: DataCollectorService,
    private projectService: ProjectsService,
    private toast: HotToastService,
    public utilityService: UtilityService) { }

  ngOnInit(): void {
    this.project_uid = this.data.project_uid;
    this.phaseDetails = this.data.phaseDetails;
    this.dateFormat = this.utilityService.dateFormat;
    this.selectedColor = this.phaseDetails?.phase_color;
    this.phaseFormGroup = this.formBuilder.group({
      name: [this.phaseDetails?.phase_name || '', [Validators.required]],
      phase_color: [ this.selectedColor || ''],
    });
  }

  selectColor(color: string): void {
    this.selectedColor = color;
  }

  getRandomNumber(): any {
    return Math.floor(Math.random() * 9);
  }

  createNewPhase(): void {
    if (this.isSubmitting) {return;};
    this.isSubmitting = true;
    this.phaseFormGroup.markAllAsTouched();
    if (!this.phaseFormGroup.invalid) {
      const loadingToast = this.toast.loading(this.utilityService.getLocaleValue('toast.creating_phase','Creating New Phase'));
      const payload = {
        phase: {
          'phase_name': this.phaseFormGroup.get('name').value,
          'phase_color': this.selectedColor || this.colors[this.getRandomNumber()],
        }
      };
      this.projectService.addPhase(this.project_uid, payload).subscribe((response: any) => {
        loadingToast.close();
        this.toast.success(response.message);
        this.dialogRef.close({status:true});
        this.isSubmitting = false;
      }, (error: any) => {
        loadingToast.close();
        this.isSubmitting = false;
      });
    }
  }

  updatePhase(): void {
    if (this.isSubmitting) {return;};
    this.isSubmitting = true;
    this.phaseFormGroup.markAllAsTouched();
    if (!this.phaseFormGroup.invalid) {
      const loadingToast = this.toast.loading(this.utilityService.getLocaleValue('toast.updating_phase','Updating Phase'));
      const payload = {
        phase: {
          'phase_name': this.phaseFormGroup.get('name').value,
          'phase_color': this.selectedColor,
        }
      };
      this.projectService.updatePhase(this.project_uid, this.phaseDetails.phase_uid, payload).subscribe((response: any) => {
        loadingToast.close();
        this.toast.success(response.message);
        payload['phase_uid'] =  this.phaseDetails.phase_uid;
        this.dialogRef.close({status:true, payload});
        this.isSubmitting = false;
      }, (error: any) => {
        loadingToast.close();
        this.isSubmitting = false;
      });
    }
  }

}
